<app-header [progress]="6" [title]="locale.currentTranslation.overviewHeader" data-testid="overview-header"></app-header>
<div class="base-content-container" data-testid="overview-container">
  <div class="headline3" data-testid="overview-title">{{ locale.currentTranslation.overview1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 32px;">
    <div data-testid="accident-description-section" class="overview-section">
      <div class="label1 header-container">
        <div>
          {{ locale.currentTranslation.accidentDescriptionHeader }}
        </div>
        <img height="20" ngSrc="assets/img/pen.svg" routerLink="/user-participation" width="20" data-testid="edit-accident-description" role="button" tabindex="0" alt="Edit accident description">
      </div>
      <div class="grey-box text-body1">
        <div>
          <div class="caption1">{{ locale.currentTranslation.yourRole }}</div>
          <div>
            {{ mapUserType() }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.licensePlateInputPlaceholder }}</div>
          <div>
            {{ this.claimService.claimReport().licensePlate }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.accidentLocationPlaceholder1 }}</div>
          <div>
            {{ this.claimService.claimReport().incidentAddress.street }} {{ this.claimService.claimReport().incidentAddress.houseNumber }}
            , {{ this.claimService.claimReport().incidentAddress.postcode }}
            , {{ this.claimService.claimReport().incidentAddress.city }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.accidentDateAndLocation }}</div>
          <div>
            {{ this.claimService.claimReport().incidentDate | date: 'dd.MM.yyyy, HH:mm' }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.overviewDamageTypeHeader }}</div>
          <div>
            {{ mapDamageType() }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.overviewInvolvedVehicles }}</div>
          <div>
            {{ mapInvolvedVehicles() }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.overviewDetailedAccidentDescription }}</div>
          <div>
            {{ this.claimService.claimReport().detailedDescription }}
          </div>
        </div>
      </div>
    </div>

    <div data-testid="trip-information-section" class="overview-section">
      <div class="label1 header-container">
        <div>{{ locale.currentTranslation.tripInformationHeader }}</div>
        <img height="20" ngSrc="assets/img/pen.svg" routerLink="/ride-reason" width="20" data-testid="edit-trip-information" role="button" tabindex="0" alt="Edit trip information">
      </div>
      <div class="grey-box text-body1">
        <div>
          <div class="caption1">{{ locale.currentTranslation.rideReason1 }}</div>
          <div>
            {{ mapRideReason() }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.driverAge1 }}</div>
          <div>
            {{ this.claimService.claimReport().age }} {{ locale.currentTranslation.years }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.alcoholConsumption1 }}</div>
          <div>
            {{ mapBoolean(this.claimService.claimReport().hasConsumedDrugs) }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.policeReport1 }}</div>
          <div>
            {{ mapBoolean(this.claimService.claimReport().policeReportWasIssued) }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.policeDrugTest1 }}</div>
          <div>
            {{ mapBoolean(this.claimService.claimReport().policeDrugTestPerformed) }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.witnessInformation1 }}</div>
          <div>
            {{ mapBoolean(this.claimService.claimReport().witnessesAreKnown) }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.faultAllocation1 }}</div>
          <div>
            {{ mapFault() }}
          </div>
        </div>
      </div>
    </div>
    @for (witness of claimService.claimReport().witnesses; track witness; let i = $index) {
      <div data-testid="witness-section" class="overview-section">
        <div class="label1 header-container">
          <div>{{ locale.currentTranslation.overviewHeaderWitnessContactInformation }} {{ i + 1 }}</div>
          <img routerLink="/witness-details" ngSrc="assets/img/pen.svg" height="20" width="20" data-testid="edit-witness-info" role="button" tabindex="0" alt="Edit witness information">
        </div>
        <div class="grey-box text-body1">
          <div>
            <div class="caption1">{{ locale.currentTranslation.witnessSurNamePlaceholder }}</div>
            <div>
              {{ witness?.surname }}
            </div>
          </div>
          <div>
            <div class="caption1">{{ locale.currentTranslation.witnessNamePlaceholder }}</div>
            <div>
              {{ witness?.name }}
            </div>
          </div>
          <div>
            <div class="caption1">{{ locale.currentTranslation.witnessPhonePlaceholder }}</div>
            <div>
              {{ witness?.phone }}
            </div>
          </div>
          <div>
            <div class="caption1">{{ locale.currentTranslation.witnessEmailPlaceholder }}</div>
            <div>
              {{ witness?.email }}
            </div>
          </div>
        </div>
      </div>
    }
    <div data-testid="documents-section" class="overview-section">
      <div class="label1 header-container">
        <div>{{ locale.currentTranslation.documentUploadHeader }}</div>
        <img height="20" ngSrc="assets/img/pen.svg" routerLink="/document-upload-overview" width="20" data-testid="edit-documents" role="button" tabindex="0" alt="Edit document uploads">
      </div>
      <div class="grey-box text-body1">
        <div>
          <div class="caption1">
            {{ locale.currentTranslation.photos }}
          </div>
          <div style="display: flex; gap:8px; margin-top: 8px;">
            @for (fileUploadCategory of claimService.claimReport().fileUploads; track fileUploadCategory) {
              <div style="display: flex; gap:8px;">
                @for (image of fileUploadCategory.imageUrls; track image) {
                  <app-image [src]="image" [height]="56"
                             [width]="56" data-testid="uploaded-image"></app-image>
                }
              </div>
            }
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.overviewIsPoliceReportAvailable }}</div>
          <div>
            {{ mapBoolean(this.claimService.claimReport().policeReportAvailable) }}
          </div>
        </div>
        @if (this.claimService.claimReport().policeReportAvailable) {
          <div>
            <div class="caption1">{{ locale.currentTranslation.whyIsPoliceReportAvailable }}</div>
            <div>
              {{ this.claimService.claimReport().noPoliceReportReason }}
            </div>
          </div>
        }
      </div>
    </div>
    <div data-testid="personal-info-section" class="overview-section">
      <div class="label1 header-container">
        <div>{{ locale.currentTranslation.overviewContactInformation }}</div>
        <img height="20" ngSrc="assets/img/pen.svg" routerLink="/personal-information" width="20" data-testid="edit-personal-info" role="button" tabindex="0" alt="Edit personal information">
      </div>
      <div class="grey-box text-body1">
        <div>
          <div class="caption1">{{ locale.currentTranslation.witnessSurNamePlaceholder }}</div>
          <div>
            {{ claimService.claimReport().personalInformation.surname }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.witnessNamePlaceholder }}</div>
          <div>
            {{ claimService.claimReport().personalInformation.name }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.personalInformationStreetPlaceholder }}</div>
          <div>
            {{ claimService.claimReport().personalInformation.streetAndNumber }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.personalInformationZipPlaceholder }}</div>
          <div>
            {{ claimService.claimReport().personalInformation.zip }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.personalInformationCityPlaceholder }}</div>
          <div>
            {{ claimService.claimReport().personalInformation.city }}
          </div>
        </div>
        <div>
          <div class="caption1">{{ locale.currentTranslation.witnessPhonePlaceholder }}</div>
          <div>
            {{ claimService.claimReport().personalInformation.phone }}
          </div>
        </div>
        @if (claimService.claimReport().personalInformation.email) {
          <div>
            <div class="caption1">{{ locale.currentTranslation.overviewEmailPlaceholder }}</div>
            <div>
              {{ claimService.claimReport().personalInformation.email }}
            </div>
          </div>
        }
        @if (mapPreferredContactMethod()) {
          <div>
            <div class="caption1">{{ locale.currentTranslation.preferredContactMethode }}</div>
            <div>
              {{ mapPreferredContactMethod() }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div>
    <div class="card-info" data-testid="overview-info-card">
      <div style="display: flex; align-items: center; gap: 8px;">
        <img height="20" ngSrc="../../../../../assets/img/info-icon.svg" width="20">
        <div class="headline4" style="color: #0A1535;">{{ locale.currentTranslation.overviewInfoHeader }}</div>
      </div>
      <div class="text-body2">
        <div>
          {{ locale.currentTranslation.overviewInfoText1 }}
        </div>
        <div style="margin-top: 21px;">
          {{ locale.currentTranslation.overviewInfoText2 }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="main-button-spacing">
  <button (click)="nextClicked()" class="main-button" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.overviewNext }}</button>
</div>
<app-footer data-testid="overview-footer"></app-footer>
